export enum VariantInputMode {
  LIST = "LIST",
  GRID = "GRID",
}
